<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-spacer
      .text-xl.font-bold.ml-10 {{ $t('upload_file') }}
      v-spacer
      v-btn(icon @click="showDialog = false" small color="primary")
        v-icon mdi-close
    v-divider

    v-card-text.primary--text.px-6.pt-6.pb-10
      //- .mb-4
        .text-sm.font-semibold.neutral500--text.mb-2 {{ $t('document_name') }}
        v-text-field.round-xl(:placeholder="$t('enter_item', { item: $t('document_name').toLowerCase() })" outlined dense height="48" hide-details="auto" v-model="name")
      //- .mb-4
        .text-sm.font-semibold.neutral500--text.mb-2 {{ $t('notes') }} ({{ $t('optional') }})
        v-textarea.round-xl(:placeholder="$t('enter_description')" outlined hide-details height="88" v-model="notes")

      .text-sm.font-semibold.neutral500--text.mb-2 {{ $t('upload_file') }}
      v-card.round-xl.border-dashed.pa-8(link outlined v-if="!selectedFile")
        .text-center
          v-avatar.mb-3(color="neutral300" size="40")
            v-icon(color="neutral500" size="18") $yzi-upload-01
          .mb-1.text-sm 
            span.font-semibold.info--text Click to upload 
            | or drag and drop
          .text-xs.neutral500--text PDF, DOCS, JPG, PNG (max. 4MB)
        input.input-change-layout(ref="file" type="file" @change="onFileChange" accept="image/png,image/jpeg,.pdf,.doc")

      template(v-else)
        v-card.d-flex.pa-3.round-xl.mt-2(outlined @mouseover="showDeleteButton = true" @mouseleave="showDeleteButton = false" :class="{ neutral300: showDeleteButton }")
          .text-sm.flex-grow-1
            .font-medium {{ selectedFile.name }}
            .neutral500--text {{ selectedFile.size | bytesToSize }}
          v-btn.my-auto(v-if="showDeleteButton" icon small @click="deleteFile")
            v-icon(color="neutral500") $yzi-trash-03
          v-icon.ml-4(v-else size="22" color="success") $yzi-check-circle-solid

    v-divider
    v-card-actions.py-3.px-6
      v-btn.button-md.underline.px-0(@click="showDialog = false" text) {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(@click="done" color="primary" depressed :disabled="disabledButton" :loading="isLoading") {{ $t('done') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { isFileSizeOverLimit } from '@/utils'

export default {
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    id: {
      required: true,
    }
  },
  data: () => ({
    name: '',
    notes: null,
    selectedFile: null,
    showDeleteButton: false,
    isLoading: false,
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    disabledButton () {
      return !this.selectedFile
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    async onFileChange (e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      if (isFileSizeOverLimit(files[0], 5)) {
        this.showMessage(['error', this.$t('error_message.file_reached_limit')])
        return
      }
      this.selectedFile = files[0]
    },
    deleteFile () {
      this.selectedFile = null
    },
    done () {
      this.isLoading = true
      const formData = new FormData()
      formData.append('doc_type', 'invoice')
      formData.append('file', this.selectedFile)
      this.$axios.post(`/clinics/${this.company.slug}/inventory_invoices/${this.id}/documents`, formData)
        .then(resp => {
          this.$emit('onUploaded', resp.data)
          this.showDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.file-layout {
  position: relative;
  cursor: pointer;
  border: var(--v-neutral400) dashed 1px;
}
.input-change-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
</style>